import React, { useState, useEffect } from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { chartsTooltipClasses } from "@mui/x-charts";

const AreaChart = (props) => {
  const [height, setHeight] = useState(260);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2560) {
        setHeight(360);
      } else if (window.innerWidth < 2560 && window.innerWidth >= 2400) {
        setHeight(340);
      } else if (window.innerWidth < 2400 && window.innerWidth >= 2133) {
        setHeight(305);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setHeight(275);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setHeight(250);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setHeight(225);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setHeight(192);
      } else {
        setHeight(260);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  const margin = {
    top: height * 0.015,
    right: height * 0.003,
    bottom: height * 0,
    left: -20,
  };

  return (
    <LineChart
      skipAnimation={false}
      height={height}
      dataset={props?.dataToShow}
      hideLegend={true}
      xAxis={[
        {
          id: "Months",
          dataKey: "month",
          scaleType: "time",
          valueFormatter: (date) =>
            `${date.toLocaleString("default", { month: "short" })} '${date
              .getFullYear()
              .toString()
              .slice(-2)}`,
          tickLabelStyle: {
            fontSize: "0.65em",
            fontWeight: "600",
            // display: "none",
          },
        },
      ]}
      yAxis={[
        {
          disableTicks: true,
          tickLabelStyle: {
            fontSize: "0.625em",
            fontWeight: "700",
          },
        },
      ]}
      slotProps={{
        tooltip: {
          sx: {
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.valueCell}`]:
              {
                fontSize: height / 16,
              },
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.labelCell}`]:
              {
                fontSize: height / 18,
              },
          },
        },
      }}
      tooltip={{ trigger: "item" }}
      margin={margin}
      {...props}
    />
  );
};

export default AreaChart;
